


<div class="pt-3">
    <div *ngIf="dashboardLoading" class="text-center">
        <p-progressSpinner></p-progressSpinner>
    </div>
    <div *ngFor="let week of dashboardData" class="grid nested-grid">
        <div class="col-12 surface-500">
            <div class="grid formgrid">
                <div class="col-12">
                    <label class="font-bold">{{week.groupPlateCountText}}</label>
                    <label class="pl-1">{{week.groupRemainingOfflinePlateCountText}}</label>
                </div>
                <div class="col-12">
                    <label class="font-bold">{{week.groupSampleCountText}}</label>
                    <label class="pl-1">{{week.groupEstimatedOfflineSampleCountText}}</label>
                </div>
                <div class="col-12">
                    <label class="font-light">{{week.groupDateRangeText}}</label>
                </div>
            </div>
        </div>
        <div class="col-12 md:col-6 lg:col-4 xl:col-3">
            <div *ngFor="let day of week.dayStats" class="grid formgrid">
                <div class="col-2 font-bold">
                    <div class="surface-500 m-auto" [style.width.px]="day.sampleCountCircleDiameter" 
                        [style.height.px]="day.sampleCountCircleDiameter" [style.border-radius.px]="day.sampleCountCircleRadius">
                    </div>
                </div>
                <div class="col-10">
                    <div class="grid formgrid">
                        <div class="col-7">
                            <div class="grid formgrid">
                                <div class="col-12 ">
                                    <label class="font-bold">{{day.plateCountText}}</label>
                                    <label class="pl-1 text-sm">{{day.offlinePlateCountText}}</label>
                                </div>
                                <div class="col-12">
                                    <label class="font-bold">{{day.sampleCountText}}</label>
                                </div>
                                <div class="col-12">
                                    <label>{{day.stats.date | date: "EEE, MM/dd/yy"}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-5 text-right text-sm">
                            <div class="grid formgrid">
                                <div class="col-12 text-red-500">
                                    {{day.plateAndSampleCount24Text}}
                                </div>
                                <div class="col-12 text-yellow-500">
                                    {{day.plateAndSampleCount48Text}}
                                </div>
                                <div class="col-12 text-green-500 border-bottom-1 border-primary">
                                    {{day.plateAndSampleCount72Text}}
                                </div>
                                <div class="col-12 text-500">
                                    {{day.plateAndSampleCountOfflineText}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 pt-0">
                    <hr class="text-center mt-0">
                </div>
            </div>
        </div>
    </div>
</div>